import { BookingAction } from '../booking-action';
import {
  BookingParams,
  BookingPosition,
  BookingResult,
  StockTargetType,
} from '../../types';

/**
 * Car-only-Welt: Quelle Maschine.
 *
 * Nur die Rücknahme aufs Fahrzeug (M→KFZ) ist gültig und movement-los: es wird
 * nur das lokale Fahrzeuglager (`CAR_STORAGE`) erhöht. Das Maschinenlager wird
 * nicht gebucht, die remote Car-Buchung passiert beim Auftragsabschluss im
 * Backend.
 */
export class CarOnlyFromMachineAction extends BookingAction {
  /**
   * Routet die Buchung nach `targetType`; einzig M→KFZ (Rücknahme) ist
   * gültig, andere Ziele sind in der Car-only-Welt nicht verfügbar.
   *
   * @param position Zu buchende Position (article_id und amount)
   * @param params Buchungskontext, Adapter und stabile client_ids
   * @returns BookingResult der Rücknahme bzw. Fehler bei unzulässigem Ziel
   */
  public async execute(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    this.debugInfo('[from-machine:car-only]', position, params);
    switch (params.context.booking.targetType) {
      case StockTargetType.CAR:
        return this.toCar(position, params);
      default:
        return this.failure(
          `Maschine → ${params.context.booking.targetType} ist in dieser Welt nicht verfügbar`,
        );
    }
  }

  /**
   * Maschine → KFZ (Rücknahme): movement-los, nur lokales Fahrzeuglager +amount.
   *
   * @param position Zu buchende Position (article_id und amount)
   * @param params Buchungskontext, Adapter und stabile client_ids
   * @returns BookingResult; Fehler ohne lokales Fahrzeuglager, bei amount <= 0 oder Update-Fehlschlag
   */
  protected async toCar(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    const { adapters } = params;
    if (!adapters.car.hasLocalInventory()) {
      return this.failure('Maschine->KFZ: kein lokales Fahrzeuglager vorhanden');
    }
    if (position.amount <= 0) {
      return this.failure('Maschine->KFZ: amount muss > 0 sein');
    }
    const carUpdated = await adapters.car.updatePositionAmountLocal(
      position,
      +position.amount,
    );
    if (!carUpdated) {
      return this.failure('Car-Bestand konnte nicht aktualisiert werden');
    }
    return this.success();
  }
}
